import cn from 'classnames';

export enum Direction {
    Left = 'left',
    Right = 'right',
}

interface NavBtnProps {
    direction: Direction;
    onClick: () => void;
    disabled?: boolean;
    className?: string;
    testId?: string;
}

export const NavBtn = ({ direction, onClick, disabled, className, testId }: NavBtnProps) => {
    const isLeft = direction === Direction.Left;

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={cn('date-picker__nav-btn', className)}
            aria-label={`${isLeft ? 'forrige' : 'neste'} måned`}
            title={`${isLeft ? 'Forrige' : 'Neste'} måned`}
            data-testid={testId}>
            {isLeft ? <w-icon name="ChevronLeft" size="small" aria-hidden /> : <w-icon name="ChevronRight" size="small" aria-hidden />}
        </button>
    );
};
